import ReactGA from 'react-ga4';
import { ENV_WITHOUT_LOCALHOST, GOOGLE_ANALITYCS_ID } from '../config';

export const WEB_SCRAPER_CATEGORY = 'Web Scraper';
export const BATCH_ID_CATEGORY = 'Batch id';

export const initGoogleAnalytics = (): void => {
  if (ENV_WITHOUT_LOCALHOST === 'dev' && GOOGLE_ANALITYCS_ID) {
    ReactGA.initialize(GOOGLE_ANALITYCS_ID);
  }
};

export const setPageViewGoogleAnalytics = (pagePath: string): void => {
  ReactGA.send({ hitType: 'pageview', page: pagePath });
};

export const eventGoogleAnalytics = (
  category: string,
  action: string,
  params: Record<string, unknown> = {}
): void => {
  ReactGA.event(action, { category, ...params });
};
